import { render } from "./VsudButton.vue?vue&type=template&id=4e41824b"
import script from "./VsudButton.vue?vue&type=script&lang=js"
export * from "./VsudButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__